import React from 'react';
import { Select } from 'antd';
import countries from './countryList';

export const countries_list = countries.map((country) => (
  <Select.Option key={Object.keys(country)[0]} value={Object.keys(country)[0]}>
    {country[Object.keys(country)[0]]}
  </Select.Option>
));

const CountrySelect = (props) => {
  return (
    <Select
      disabled={props.disabled}
      onChange={props.onChange}
      value={props.value}
      mode={props.mode || 'multiple'}
      allowClear={false}
      style={props.style || {}}
      placeholder="Select Country"
      showArrow
      filterOption={(input, option) =>
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {countries_list}
    </Select>
  );
};

export default CountrySelect;
